export default "__VITE_ASSET__7cdeb198__"